import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Product } from "@dashboard/modules/products/types/products.types";
import { CouponBucket } from "../constants/coupons.constants";
import { Coupon, CouponDraft } from "../entities/coupon.entity";
import { createEmptyCouponDraft } from "../utils/validate-coupon";
import { initialState } from "./coupons.state";

const couponsSlice = createSlice({
  name: "coupons",
  initialState,
  reducers: {
    setUi: (
      state,
      { payload }: PayloadAction<Partial<typeof initialState.ui>>
    ) => {
      state.ui = { ...state.ui, ...payload };
    },
    setCoupons: (state, { payload }: PayloadAction<Coupon[]>) => {
      state.data.coupons = payload;
    },
    setCatalogueProducts: (state, { payload }: PayloadAction<Product[]>) => {
      state.data.catalogueProducts = payload;
    },
    setSelectedCoupon: (
      state,
      { payload }: PayloadAction<Coupon | undefined>
    ) => {
      state.data.selectedCoupon = payload;
    },
    setDraftCoupon: (
      state,
      { payload }: PayloadAction<Partial<CouponDraft>>
    ) => {
      state.data.draftCoupon = { ...state.data.draftCoupon, ...payload };
    },
    resetDraftCoupon: (state) => {
      state.data.draftCoupon = createEmptyCouponDraft();
    },
    loadDraftFromCoupon: (state, { payload }: PayloadAction<Coupon>) => {
      state.data.draftCoupon = { ...payload };
    },
    updateCouponInList: (state, { payload }: PayloadAction<Coupon>) => {
      const index = state.data.coupons.findIndex((c) => c.id === payload.id);
      if (index !== -1) {
        state.data.coupons[index] = payload;
      } else if (payload.id) {
        state.data.coupons.push(payload);
      }
    },
    removeCouponFromList: (state, { payload }: PayloadAction<string>) => {
      state.data.coupons = state.data.coupons.filter((c) => c.id !== payload);
    },
    setSearchQuery: (state, { payload }: PayloadAction<string>) => {
      state.ui.searchQuery = payload;
    },
    toggleFilter: (state, { payload }: PayloadAction<CouponBucket>) => {
      const exists = state.ui.activeFilters.includes(payload);
      state.ui.activeFilters = exists
        ? state.ui.activeFilters.filter((f) => f !== payload)
        : [...state.ui.activeFilters, payload];
    },
  },
});

export const couponsActions = couponsSlice.actions;
export default couponsSlice.reducer;
